import isNil from "ramda/es/isNil";
import { currencyFormatter } from "@/util-modules/currency";

export function configureFilters(Vue) {
  Vue.filter("currency", function(value) {
    if (value === "" || isNil(value)) return "";
    return currencyFormatter(parseFloat(value));
  });
}
